import React from "react";
import { NavLink } from "react-router";
import { touch, grain } from "@src/assets/icons";
import {
  signolImagesRepositoryURL,
  URL_SIGNOL_LEGAL_POLICIES,
  UserTypes,
} from "@src/constants/constants";
import { AppUtils, SignolUtils } from "@src/utils";
import { useAuthContext } from "@src/context";
import { ImageWithRetry } from "@src/components/atoms";

const AppFooter = (props) => {
  const { currentAppVersion, cacheVersion } = props;
  const { isActiveRoleAdmin, activeRoleRoutePrefix } = useAuthContext();
  const showSupportPageLink = !isActiveRoleAdmin;

  return (
    <>
      <div className="p-4 sm:p-6 bg-gray-900 w-full z-50">
        <div className="flex justify-between max-w-7xl mx-auto">
          <div className="px-2 text-white text-xs sm:text-sm">
            <ImageWithRetry
              src={`${signolImagesRepositoryURL}/SignolLogoWhite.png`}
              alt="Signol logo"
              className="w-16"
              width="60"
            />
            <div className="text-left">Version {currentAppVersion}</div>
            <div className="text-left text-xs italic">
              {!!cacheVersion ? `(${cacheVersion})` : ""}
            </div>
            <div className="text-left">
              Signol {new Date().getFullYear()} © All Rights Reserved
            </div>
          </div>
          <div className="p-4">
            <div className="flex flex-col sm:flex-row justify-end">
              {showSupportPageLink && (
                <NavLink
                  {...SignolUtils.makeTrackableDataAttributes({
                    type: "MENU_ITEM",
                    toURL: `/dashboard/${activeRoleRoutePrefix}/support`,
                  })}
                  to={`/dashboard/${activeRoleRoutePrefix}/support`}
                  className={`mx-4 mb-2 text-white${
                    window.location.pathname ===
                    `/dashboard/${activeRoleRoutePrefix}/support`
                      ? " pointer-events-none"
                      : ""
                  }`}
                >
                  <div className="flex cursor-pointer items-center">
                    <div className="h-8 w-8 rounded-full bg-white p-1 text-gray-600">
                      {touch()}
                    </div>
                    <div className="ml-3">
                      <p className="text-white text-sm sm:text-lg font-bold">
                        Support
                      </p>
                    </div>
                  </div>
                </NavLink>
              )}
              <div className="mx-4 text-white">
                <a
                  {...SignolUtils.makeTrackableDataAttributes({
                    type: "MENU_ITEM",
                    toURL: URL_SIGNOL_LEGAL_POLICIES,
                  })}
                  href={URL_SIGNOL_LEGAL_POLICIES}
                  className="text-white text-sm sm:text-lg font-bold cursor-pointer"
                  target="_blank"
                >
                  <div className="flex cursor-pointer items-center">
                    <div className="h-8 w-8 rounded-full bg-white py-2 text-gray-600">
                      {grain()}
                    </div>
                    <div className="ml-3">Legal</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppFooter;

export const AppFooterControls = {
  currentAppVersion: {
    controlType: "Text",
    description: "Version Number of the app",
  },
  cacheVersion: {
    controlType: "text",
    description: "Current Cache Version",
  },
};

AppFooter.propTypes = AppUtils.getPropTypeFromControls(AppFooterControls);

// @inject('rootStore')
// @observer
// class DashboardFooter extends React.Component {
//   @observable supportPopup = false;
//   @observable requestSent = false;
//   @observable cacheVersion;
//   supportMessage = '';

//   componentDidMount = async () => {
//     const getCacheActiveVersion = async () => {
//       const cacheData = {};
//       // List of all caches present in browser
//       const names = await caches.keys();
//       const cacheVersions = names.map(async name => {
//         cacheData[name] = 0;
//         const cacheStorage = await caches.open(name);
//         const cachedResponse = await cacheStorage.match(window.location.origin);
//         const data = await cachedResponse.text();
//         cacheData[name] += data.trim().length;
//         return name;
//       });
//       return cacheVersions[0]; // return the active cache
//     };
//     this.cacheVersion = await getCacheActiveVersion();
//   };

//   handleMessageChange = (e, { value }) => (this.supportMessage = value);

//   onValidSubmit = formdata => {
//     const creationRequest = {
//       organization: formdata.organization,
//       fullname: formdata.fullname,
//       email: formdata.email,
//       message: this.supportMessage
//     };

//     this.props.rootStore.actionSubmitSupport(creationRequest);
//     this.requestSent = true;
//   };

//   handleOpen = () => (this.supportPopup = true);
//   handleClose = () => {
//     this.supportPopup = false;
//     this.requestSent = false;
//   };

//   render() {
//     return (
//       <>
//         <div className="p-4 sm:p-6 bg-gray-900 w-full">
//           <div className="flex justify-between max-w-7xl mx-auto">
//             <div className="px-2 text-white text-xs sm:text-sm">
//               <img
//                 src={`${signolImagesRepositoryURL}/SignolLogoWhite.png`}
//                 className="w-16"
//                 width="60"
//               />
//               <div className="text-left">Version {this.props.rootStore.currentAppVersion}</div>
//               <div className="text-left text-xs italic">({this.cacheVersion})</div>
//               <div className="text-left">Signol {new Date().getFullYear()} © All Rights Reserved</div>
//             </div>
//             <div className="p-4">
//               <div className="flex justify-end">
//                 {!this.props.isManager && (
//                   <Link
//                     to="/dashboard/support"
//                     className={`mx-4 text-white${
//                       this.props.locationPath === '/dashboard/support' ? ' pointer-events-none' : ''
//                     }`}
//                   >
//                     <div className="flex cursor-pointer items-center">
//                       <div className="h-8 w-8 rounded-full bg-white py-2 text-gray-600">{touch()}</div>
//                       <div className="ml-3">
//                         <p className="text-white text-sm sm:text-lg font-bold">Support</p>
//                       </div>
//                     </div>
//                   </Link>
//                 )}
//                 <div className="mx-1 text-white">
//                   <a
//                     href="https://www.signol.io/app-legal/"
//                     className="text-white text-sm sm:text-lg font-bold cursor-pointer"
//                   >
//                     <div className="flex cursor-pointer items-center">
//                       <div className="h-8 w-8 rounded-full bg-white py-2 text-gray-600">{grain()}</div>
//                       <div className="ml-3">Legal</div>
//                     </div>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }
// }
